import React, { useEffect } from 'react';
import Slider from './Slider';
import Title from '../common/Title';

export default function SliderWithTitle (props) {
  const passTypeList = ['spot', 'subspot', 'live', 'program', 'event', 'ad'];
  let mainContentsType;

  if (passTypeList.includes(props.type)) {
    mainContentsType = props.type;
  } else if (props.type === 'new_vod') {
    mainContentsType = 'newvod ';
  }else if (props.type === 'pnews'){
    mainContentsType = 'soup';
  } else {
    mainContentsType = 'hotclip';
  }

  let imageQuality = 50;

  let sliderType;
  switch (props.type) {
    case 'poster':
    case 'program':
      sliderType = 'poster';
      break;
    case 'event':
      sliderType = 'event';
      break;
    case 'live':
      sliderType = 'thumb'; // 640
      imageQuality = 70;
      break;
    default:
      sliderType = 'thumb';
  }
  return (

    // <div className={'main_contents_' + mainContentsType}>
    <div className={props.wrapperClass || 'main_contents_' + mainContentsType}>

      <Title type={props.type} title={props.title} desc={props.desc} link={props.link} mainContentsType={mainContentsType} />
      {/* 라이브 인지 아닌지 구분해서 뿌리는 로직 필요함 */}
      {/* <Slider type='thumb' data={props.data} /> */}
      <Slider
        view={props.view}
        type={sliderType}
        data={props.data}
        relate_id={props.relate_id}
        relate_title={props.relate_title}
        relate_title_view_yn={props.relate_title_view_yn}
        relate_type={props.relate_type}
        bottom_type={props.bottom_type}
        clickParams={props.clickParams}
      />

    </div>

  );
}
